module.exports = __webpack_public_path__ + "01_very_short_grey.ae2a567c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/01_very_short_grey.png
// module id = Rnzf
// module chunks = 0